
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"9","stroke":"#A6B7D4","stroke-width":"2"}}),_c('rect',{attrs:{"x":"11","y":"5","width":"2","height":"9","rx":"1","fill":"#A6B7D4"}}),_c('rect',{attrs:{"x":"11.588","y":"11.925","width":"2.002","height":"5.802","rx":"1.001","transform":"rotate(39.365 11.588 11.925)","fill":"#A6B7D4"}})])
          )
        }
      }
    